import { render, staticRenderFns } from "./templateRelationDetailDialog.vue?vue&type=template&id=fbb29d28&"
import script from "./templateRelationDetailDialog.vue?vue&type=script&lang=js&"
export * from "./templateRelationDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./templateRelationDetailDialog.vue?vue&type=style&index=0&id=fbb29d28&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports